export default "__VITE_PUBLIC_ASSET__aaf018d6__"